import React, { useEffect } from "react";
import { Col, pagination, Row, Table } from "antd";
import { onShowSizeChange, itemRender } from "../Pagination";
import { Link } from "react-router-dom";
import { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  imagesend,
  plusicon,
  refreshicon,
  searchnormal,
} from "../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import AddModal from "./AddModal";
import { getInstruction } from "../../services/doctor/instruction/instruction";
import Loader from "../Loader";
import { useAuth } from "../../services/authentication_API/authService";

const Instructions = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const { userData } = useAuth();

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const [show, setShow] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const [selectedData, setSelectedData] = useState(null)
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const fetchInstruction = async () => {
    try {
      setLoading(true);
      const result = await getInstruction(searchKeyword,userData?.id);
      if (result.success) {
        const formattedData = result.data.map((item, index) => ({
          ...item,
          id: item.id || `${Date.now()}-${index}`,
          FindingName: item?.name, 
        }));
        setDatasource(formattedData);
        setLoading(false);
      } else {

        setDatasource([]);
      }
    } catch (err) {
      setDatasource([]);
    }
  };
  useEffect(() => {
    fetchInstruction();
  }, [refresh,searchKeyword]);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.InstructionName.length - b.InstructionName.length,
    },
    // {
    //   title: "Description",
    //   dataIndex: "Description",
    //   sorter: (a, b) => a.Description.length - b.Description.length,
    // },
    {
      title: "",
      dataIndex: "FIELD8",
      render: (text, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to="#" onClick={()=>{setShow(true), setisEdit(true),setSelectedData(record)}}>
                  <i className="far fa-edit me-2" />
                  Edit
                </Link>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_patient"
                >
                  <i className="fa fa-trash-alt m-r-5"></i> Delete
                </Link>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);
  return (
    <div>
      <Sidebar id="menu-item1" id1="menu-items1" activeClassName="instructions" />
      <div className="page-wrapper-doctor">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Doctor&apos;s Setting </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Instructions</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <Row className="mb-12">
                  <Col sm={12}>
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Instructions List</h3>
                              <div className="doctor-search-blk">
                                <div className="top-nav-search table-search-blk">
                                  <form>
                                  <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search here"
                                      onChange={(e) => {setSearchKeyword(e.target.value)}}
                                    />
                                    <Link className="btn" onClick={(e)=>fetchInstruction()}>
                                      <img src={searchnormal} alt="#" />
                                    </Link>
                                  </form>
                                </div>
                                <div className="add-group">
                                <Link
                                    to="#"
                                    onClick={()=>{setShow(true), setisEdit(false),setSelectedData(null)}}
                                    className="btn btn-primary add-pluss ms-2"
                                  >
                                    <img src={plusicon} alt="#" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="btn btn-primary doctor-refresh ms-2"
                                    onClick={(e) => setRefresh(!refresh)}
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}
                      {loading ? <Loader/> :
                      <div className="table-responsive">
                       
                        <Table
                          pagination={{
                            total: datasource.length,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            itemRender: itemRender,
                            style: { paddingRight: "14px" },
                          }}
                          columns={columns}
                          dataSource={datasource}
                          rowSelection={rowSelection}
                          rowKey={(record) => record.id}
                        />
                      
                      
                      </div>}
                    </div>
                  </Col>
                </Row>
                <AddModal
        show={show}
        onHide={() => setShow(false)}
        refresh={()=> setRefresh(!refresh)}
        type="Instructions"
        isedit={isEdit}
        data={selectedData}
        
        
      />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Modal */}
      <div
        id="delete_patient"
        className="modal fade delete-modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to delete this?</h3>
              <div className="m-t-20">
                <Link
                  to="#"
                  className="btn btn-white me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button type="submit" className="btn btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;



